import { ServiceContent } from './types';
import { civilLawData } from './civilLaw';
import { propertyLawData } from './propertyLaw';
import { criminalLawData } from './criminalLaw';
import { bankingLawData } from './bankingLaw';
import { consumerLawData } from './consumerLaw';
import { insuranceLawData } from './insuranceLaw';
import { arbitrationLawData } from './arbitrationLaw';
import { chitFundData } from './chitFund';
import { debtRecoveryTribunalData } from './debtRecoveryTribunal';
import { electricityLawData } from './electricityLaw';

// Export types
export * from './types';

// Export individual service data
export {
    civilLawData,
    propertyLawData,
    criminalLawData,
    bankingLawData,
    consumerLawData,
    insuranceLawData,
    arbitrationLawData,
    chitFundData,
    debtRecoveryTribunalData,
    electricityLawData
};

// Export aggregated object
export const servicesData: Record<string, ServiceContent> = {
    'civil-law': civilLawData,
    'property-law': propertyLawData,
    'criminal-law': criminalLawData,
    'banking-law': bankingLawData,
    'consumer-law': consumerLawData,
    'insurance-law': insuranceLawData,
    'arbitration-law': arbitrationLawData,
    'chit-fund': chitFundData,
    'debt-recovery-tribunal': debtRecoveryTribunalData,
    'electricity-law': electricityLawData
};
